<template>
	<div class="page-list">
		<com-page-title   ></com-page-title>
	<el-calendar>
		
			   <template
			       slot="dateCell"
			       slot-scope="{date, data}">
			       <p style="width: 100%;height: 100%;" :class="data.isSelected ? 'is-selected' : ''" @click="calendarOnClick(data)">
			         {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}
			       </p>
			     </template>
	</el-calendar> 
	</div>
</template>

<script>
	 export default {
	    data() {
	      return {
			range:['2021-12-01',this.$getTime("yyyymmdd") ],
	      }
	    },
		methods:{
			calendarOnClick(e){
				window.open(this.$domain+'/logs/logs_'+e.day.replace(/[-]/g,"")+'.txt','_blank');
			}
		}
	  }
</script>

<style>
</style>
